import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_2 = { class: "modal-content border-0 shadow-lg rounded-4" }
const _hoisted_3 = { class: "modal-header border-bottom-dashed" }
const _hoisted_4 = { class: "modal-chip" }
const _hoisted_5 = { class: "modal-title fw-bold mt-3 mb-1" }
const _hoisted_6 = { class: "text-muted mb-0" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "modal-body p-4 p-xl-40" }
const _hoisted_9 = { class: "size-tip-card mb-4" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "mb-0 text-muted" }
const _hoisted_12 = { class: "row g-3" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "field-header" }
const _hoisted_15 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_16 = { class: "field-caption" }
const _hoisted_17 = ["value", "placeholder"]
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "field-header" }
const _hoisted_21 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_22 = { class: "field-caption" }
const _hoisted_23 = ["value", "placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "field-header" }
const _hoisted_27 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_28 = { class: "field-caption" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { value: 1 }
const _hoisted_31 = { value: 0 }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "field-header" }
const _hoisted_34 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_35 = { class: "field-caption" }
const _hoisted_36 = ["value", "placeholder"]
const _hoisted_37 = { class: "d-flex justify-content-between align-items-center mt-4 pt-2" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal fade show d-block size-modal",
        tabindex: "-1",
        "aria-modal": "true",
        role: "dialog",
        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.isEdit ? _ctx.$t("size_page.edit_chip") : _ctx.$t("size_page.new_chip")), 1),
                _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.isEdit ? _ctx.$t("size_page.update_title") : _ctx.$t("size_page.create_title")), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("size_page.modal_description")), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close shadow-none",
                "aria-label": _ctx.$t('common.close'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "tip-icon" }, [
                  _createElementVNode("i", { class: "ri-ruler-line" })
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h6", _hoisted_10, _toDisplayString(_ctx.isEdit ? _ctx.$t("size_page.edit_tip_title") : _ctx.$t("size_page.create_tip_title")), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("size_page.tip_description")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("size_page.code")), 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("size_page.code_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.code,
                    type: "text",
                    class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.code }]),
                    placeholder: _ctx.$t('size_page.code_placeholder'),
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-field', 'code', ($event.target as HTMLInputElement).value)))
                  }, null, 42, _hoisted_17),
                  (_ctx.errors.code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.errors.code[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("size_page.name")), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("size_page.name_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.name,
                    type: "text",
                    class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.name }]),
                    placeholder: _ctx.$t('size_page.name_placeholder'),
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update-field', 'name', ($event.target as HTMLInputElement).value)))
                  }, null, 42, _hoisted_23),
                  (_ctx.errors.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.errors.name[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("size_page.status")), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("size_page.status_caption")), 1)
                  ]),
                  _createElementVNode("select", {
                    value: _ctx.normalizeStatus(_ctx.form.status),
                    class: "form-select modal-input",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update-field', 'status', Number(($event.target as HTMLSelectElement).value))))
                  }, [
                    _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t("size_page.status_active")), 1),
                    _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t("size_page.status_inactive")), 1)
                  ], 40, _hoisted_29)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("size_page.description")), 1),
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("size_page.description_caption")), 1)
                  ]),
                  _createElementVNode("textarea", {
                    value: _ctx.form.description,
                    rows: "5",
                    class: "form-control modal-input modal-textarea",
                    placeholder: _ctx.$t('size_page.description_placeholder'),
                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update-field', 'description', ($event.target as HTMLTextAreaElement).value)))
                  }, null, 40, _hoisted_36)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light px-4",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
                }, _toDisplayString(_ctx.$t("common.cancel")), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn style-one px-4 h-55",
                  disabled: _ctx.loading,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('save')))
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.$t("size_page.saving") : _ctx.isEdit ? _ctx.$t("size_page.update_action") : _ctx.$t("size_page.create_action")), 1)
                ], 8, _hoisted_38)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}